import React, { useRef, useState } from 'react';
import axios from 'axios';
import Loader from './Loader/Loader';
import { Icon } from './AppShell';

const ImageDialog = ({ dialogVisible, setDialogVisible, onUpload }) => {
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  const closeDialog = () => {
    if (!isLoading) {
      setDialogVisible(false);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsLoading(true);
      uploadImage(file);
    }
  };

  const uploadImage = (file) => {
    const formData = new FormData();
    formData.append('image', file);

    const apiKey = '8d79781c54e19eb95c3563d7f55ffc83';
    const imgbbUrl = `https://api.imgbb.com/1/upload?key=${apiKey}`;

    axios
      .post(imgbbUrl, formData)
      .then((response) => {
        const uploadedImageUrl = response.data.data.url;
        onUpload(uploadedImageUrl);
        setDialogVisible(false);
      })
      .catch((error) => {
        console.error('Ошибка загрузки изображения:', error);
        alert('Ошибка загрузки изображения');
      })
      .finally(() => {
        setIsLoading(false);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      });
  };

  if (!dialogVisible) {
    return null;
  }

  return (
    <div className="modal-backdrop" role="presentation" onClick={closeDialog}>
      <div
        className="image-upload-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="image-upload-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <div>
            <h2 id="image-upload-title">Загрузить изображение</h2>
            <p>Выберите фото блюда, оно загрузится автоматически</p>
          </div>
          <button type="button" className="icon-button small" onClick={closeDialog} aria-label="Закрыть">
            <Icon name="close" />
          </button>
        </div>

        {isLoading ? (
          <div className="upload-state">
            <Loader imageLoader="true" />
            <span>Загружаю фото...</span>
          </div>
        ) : (
          <div className="upload-picker">
            <div className="upload-icon">
              <Icon name="add_photo_alternate" />
            </div>
            <button
              type="button"
              className="primary-action"
              onClick={() => fileInputRef.current?.click()}
            >
              Выбрать фото
            </button>
            <input
              ref={fileInputRef}
              id="file"
              type="file"
              accept="image/*"
              onChange={handleChange}
              className="sr-only"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageDialog;
